module.exports = __webpack_public_path__ + "static/og-image-8cd34febbb8a3714e86cf3b2e7cd6661.jpg";